import { CSSProperties } from "react";
import { FactionType } from "~/business";
import { XFactionChangeTriangleSvg } from "./svg";
import { XFactionDiamond } from "./XFactionDiamond";

export const XFactionChange = ({
  faction,
  change,
  width,
  style,
}: {
  faction?: FactionType;
  change: number;
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "fit-content",
        ...style,
      }}
    >
      {change > 0 &&
        [...new Array(change)].map((_, index) => (
          <div key={index} style={{ marginBottom: -width * 0.33 }}>
            <XFactionChangeTriangleSvg width={width} />
          </div>
        ))}
      <XFactionDiamond width={width} faction={faction} />
      {change < 0 &&
        [...new Array(Math.abs(change))].map((_, index) => (
          <div
            key={index}
            style={{
              marginTop: -width * 0.33,
              transform: "rotate(180deg)",
              zIndex: -1,
            }}
          >
            <XFactionChangeTriangleSvg width={width} />
          </div>
        ))}
    </div>
  );
};
